import type { GeocodePointsRequest, GeocodePointsResponse, ReverseLocalitiesRequest, ReverseLocalitiesResponse } from '@numeo/types'
import axios from 'axios'
import { getApiBaseUrlWithoutV1 } from 'setup/SetupAxios'

/** main-service's geocoding endpoints. The browser never calls a geocoding vendor; the server owns them. */
const geoUrl = (path: string) => `${getApiBaseUrlWithoutV1()}/geo/geocoding/${path}`

/** Free text (a ZIP, "City, ST" or a street address) to points: one answer per query, in order, `null` where unplaced. */
export const geocodePointsApi = async (body: GeocodePointsRequest): Promise<GeocodePointsResponse> => {
    // A broker holds a broker token, not a dispatcher JWT: the same handler is mounted for them under the portal, and
    // the portal's own client sends their token (the global client would 401 and sign them out to the dispatcher login).
    // Loaded only on a broker page, so the dispatcher app's geocoding never pulls in the portal's auth module.
    if (window.location.pathname.startsWith('/broker-portal')) {
        const { brokerAxios } = await import('pages/broker-portal/useBrokerAuth')
        const brokerResponse = await brokerAxios.post<{ success: boolean; data: GeocodePointsResponse }>('/broker-portal/geocoding/points/v1', body)
        return brokerResponse.data.data
    }
    const response = await axios.post<{ success: boolean; data: GeocodePointsResponse }>(geoUrl('points/v1'), body)
    return response.data.data
}

/** Points to their country, state, city and ZIP: one answer per point, in order, `null` where unnamed. */
export const reverseLocalitiesApi = async (body: ReverseLocalitiesRequest): Promise<ReverseLocalitiesResponse> => {
    const response = await axios.post<{ success: boolean; data: ReverseLocalitiesResponse }>(geoUrl('localities/v1'), body)
    return response.data.data
}
